import React, { useState } from "react";
import Popup from "../utils/Popup";
import { useData } from "../../context/DataContext";
import Loader from "../utils/Loader";

const Cards = () => {
  const { filteredPersons,filteredPersonsLoaded } = useData()
  const [active,setActive] = useState({})
  const [open,setopen] = useState(false);
  return (
    <div className="w-100">
      <div className="container-fluid">
        <div id="photos" className="pb-5 pt-4 w-100">
          {
            filteredPersonsLoaded ? filteredPersons.map((el,i)=>{
              return <div className="px-sm-2 px-1 py-sm-3 py-2 position-relative column" key={i}>
                  <div style={{cursor: `pointer`}} onClick={()=> {
                    setActive(el);
                    setopen(true)
                  }} className="image_container">
                    {el?.photos?.[0]?.type === "image" ? <img className="shadow" src={el?.photos?.[0].src} alt={el.name}/> : el?.photos?.[0]?.type === "video" ?<video autoPlay loop playsInline className="mx-auto mw-100 shadow" muted src={el.photos?.[0].src}></video> : <div>The File You've uploaded is not Correct</div> }
                    <div className="name_outer mb-0 px-5 py-4 h5">
                      {el.name}
                    </div>
                  </div>
                </div>
            }) : <div style={{height: `100vh`}} className="position-relative">
              <Loader />
            </div>
          }
          <Popup active={active} open={open} handleClose={()=> {
            setActive({});
            setopen(false)
          }} />
        </div>
      </div>
    </div>
  );
};

export default Cards;
